import React, { useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import './ToolPage.css'
import './ShoppingList.css'
import { createShoppingList } from './utils/shoppingListStore'
import { trackEvent } from '../../lib/analytics'
import { useDocumentMeta } from '../../hooks/useDocumentMeta'

const randomItemId = () =>
  window.crypto.randomUUID ? window.crypto.randomUUID() : String(Math.random())

const ShoppingListCreate = () => {
  useDocumentMeta({
    title: 'Lista de Compras Compartilhável | jarder.dev',
    description:
      'Crie uma lista de compras e gere um link: quem abrir marca os ' +
      'itens junto com você, em tempo real. Grátis, sem cadastro.',
  })

  const history = useHistory()
  const [items, setItems] = useState([])
  const [itemInput, setItemInput] = useState('')
  const [error, setError] = useState('')
  const [status, setStatus] = useState('idle')

  const addItem = () => {
    const trimmed = itemInput.trim()
    if (!trimmed) return
    setItems((current) => [...current, { id: randomItemId(), text: trimmed, done: false }])
    setItemInput('')
  }

  const removeItem = (id) => {
    setItems((current) => current.filter((item) => item.id !== id))
  }

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault()
      addItem()
    }
  }

  const create = async () => {
    if (items.length === 0) {
      setError('Adicione pelo menos um item.')
      return
    }
    setError('')
    setStatus('loading')
    try {
      const id = await createShoppingList(items)
      trackEvent('tool_generate', { tool: 'shopping_list', count: items.length })
      history.push(`/ferramentas/lista-de-compras/${id}`)
    } catch {
      setError('Não foi possível criar a lista agora. Tente novamente.')
      setStatus('idle')
    }
  }

  return (
    <div className="tool-page">
      <Link to="/ferramentas" className="tool-back-link">
        ← Todas as ferramentas
      </Link>
      <h1>Lista de Compras Compartilhável</h1>
      <p className="tool-disclaimer">
        Monte a lista, gere o link e mande pra quem for junto com você.
        Qualquer pessoa com o link pode marcar itens e adicionar novos, em
        tempo real.
      </p>

      <div className="tool-field">
        <label htmlFor="item-name">Itens ({items.length})</label>
        <div className="chip-input-row">
          <input
            id="item-name"
            type="text"
            value={itemInput}
            onChange={(e) => setItemInput(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder="Ex: 2kg de arroz, aperte Enter"
          />
          <button type="button" className="tool-button tool-button-secondary" onClick={addItem}>
            Adicionar
          </button>
        </div>
      </div>

      {items.length > 0 && (
        <ul className="chip-list">
          {items.map((item) => (
            <li className="chip" key={item.id}>
              {item.text}
              <button
                type="button"
                className="chip-remove"
                onClick={() => removeItem(item.id)}
                aria-label={`Remover ${item.text}`}
              >
                ×
              </button>
            </li>
          ))}
        </ul>
      )}

      {error && <p className="tool-error">{error}</p>}

      <button
        type="button"
        className="tool-button"
        onClick={create}
        disabled={status === 'loading'}
      >
        {status === 'loading' ? 'Criando lista...' : 'Criar lista e gerar link'}
      </button>

      <div className="tool-info-section">
        <h2>Como funciona o compartilhamento</h2>
        <p>
          Ao criar a lista, você recebe um link único. Qualquer pessoa
          que abrir esse link vê os mesmos itens e pode marcar como
          comprado ou adicionar novos em tempo real  útil para dividir
          as compras do mês com quem mora com você, sem precisar ficar
          mandando mensagem perguntando "já comprou o quê?".
        </p>
      </div>
    </div>
  )
}

export default ShoppingListCreate
